let activeCollection = null;

document.addEventListener('DOMContentLoaded', function() {
  const carouselSection = document.getElementById('collCarouselEl');
  const carousels = carouselSection.querySelectorAll('.collCarousel__carousel');

  updateActiveCollection = () => {
    carousels.forEach(carousel => {
      if (carousel.dataset.collection === activeCollection) {
        carousel.classList.add('active');
      } else {
        carousel.classList.remove('active');
      }
    });
  };

  if (carouselSection) {
    const switcherButtons = carouselSection.querySelectorAll('.switcherButton');
    switcherButtons.forEach(button => {
      button.addEventListener('click', function() {
        activeCollection = this.dataset.collection;

        switcherButtons.forEach(btn => btn.classList.remove('active'));
        this.classList.add('active');

        updateActiveCollection();

        console.log('Active collection:', activeCollection);
      });
    });
  }
});
